// removed by extract-text-webpack-plugin
module.exports = {"switch":"switch","switch-label":"switch-label","switch-control":"switch-control","input-checkbox":"input-checkbox","toggled":"toggled","disabled":"disabled"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/switch/switch.style.sass
// module id = Nnmi
// module chunks = 0